import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Local Imports 
import { useIsAuthenticatedUser } from '../utils/utils';

const PublicRoutes = () => {
  const location = useLocation();
  const user = useSelector((state) => state?.user?.user);
  const { isAuthenticated } = useIsAuthenticatedUser();
  const fromPathname = location?.state?.from?.pathname;

  // Share links, invites, and reset-password must stay reachable when logged in.
  if (
    location?.pathname === '/reset-password' ||
    location?.pathname.startsWith('/files/shared/') ||
    location?.pathname.startsWith('/projects/invite/') ||
    location?.pathname.startsWith('/teams/invite/')
  ) {
    return <Outlet />;
  }

  if (isAuthenticated) {
    if (location?.pathname === '/signup') {
      return <Navigate to='/dashboard' replace />;
    } else {
      if (fromPathname) {
        return <Navigate to={fromPathname} replace />;
      }
      if (user?.all_user_permissions?.includes('superadmin')) {
        return <Navigate to='/dashboard' replace />;
      }
      return <Navigate to='/dashboard' replace />;
    }
  } else {
    return <Outlet />;
  }
};

export default PublicRoutes;
